export const MAINTENANCE_ERROR_CODES = [503, 599]; // assuming 503 and 599 is the maintenance error code
